import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-total-benefit-eligible",
    prompt: (guidanceItem) => `Please enter Total Benefit Eligible. This total will be used for billing of Telescope Health and Intellect services. Your enrollments with Ameriflex should include all benefit eligible employees to ensure they have access to these virtual care and mental health services.`, 
    briefDescription: 'Total Benefit Eligible',
    openAction: {
        text: "Where to edit Total Benefit Eligible?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/general`,
        row: "Name",
    },
    completeAction: {
    }

});


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-total-benefit-eligible.js